import React from 'react';
import { Tabs } from '@/shared/components/Tabs';
import { cn } from '@/shared/utils/cn';
import { MessageBox } from '@schuettflix/react-components';
import { useTranslation } from 'react-i18next';
import { ProcessingType } from '@/shared/models/ContextDataModel/interfaces/enums/processing-type.ts';

type ProcessingTypeToggleProps = Pick<React.HTMLAttributes<HTMLFormElement>, 'className'> & {
    value: ProcessingType;
    onChange: (value: ProcessingType) => void;
};

export function ProcessingTypeToggle({ onChange, className, value }: ProcessingTypeToggleProps) {
    const { t } = useTranslation();

    return (
        <div className={cn('flex flex-col gap-6', className)}>
            <div className="border-b-2">
                <Tabs.Root
                    value={value}
                    onValueChange={value => onChange(value as ProcessingType)}
                    className="-mb-[2px]"
                >
                    <Tabs.List>
                        <Tabs.Trigger value="AUTOMATIC" data-test="processing-type-automatic">
                            {t('processingTypeToggle.processingType.automatic')}
                        </Tabs.Trigger>
                        <Tabs.Trigger value="MANUAL" data-test="processing-type-manual">
                            {t('processingTypeToggle.processingType.manual')}
                        </Tabs.Trigger>
                    </Tabs.List>
                </Tabs.Root>
            </div>
            {value === 'AUTOMATIC' && (
                <MessageBox type="info">{t('processingTypeToggle.processingType.automaticHint')}</MessageBox>
            )}
        </div>
    );
}
